import { MoneyFormatter, StringFormatter } from 'namirasoft-site-react';
import Styles from './NSPOfferItemCardPriceDominant.module.css';

export interface NSPOfferItemCardPriceDominantProps
{
	price: number;
	currency: string;
	was?: string | null;
	per?: string;
	subtitle?: string;
	description?: string;
}

export function NSPOfferItemCardPriceDominant(props: NSPOfferItemCardPriceDominantProps)
{
	return (
		<>
			<div className='d-flex flex-row justify-content-center align-items-center gap-3'>
				{
					props.was &&
					<div className={Styles.nsp_offer_item_card_price_dominant_was_parent}>
						<div className={Styles.nsp_offer_item_card_price_dominant_was}>
							<h6>{props.currency}</h6>
							<h2>
								{props.was}
							</h2>
						</div>
						<span className={Styles.nsp_offer_item_card_price_dominant_was_diameter}></span>
					</div>
				}
				{
					<div
						className={Styles.nsp_offer_item_card_price_dominant_parent}
					>
						<div
							className={Styles.nsp_offer_item_card_price_dominant}
						>
							<h6>{props.currency}</h6>
							<h2>
								{new MoneyFormatter("", "", 2, 5).format(props.price)}
							</h2>
						</div>
						{
							props.per &&
							<span>{StringFormatter.toHTML(props.per)}</span>
						}
					</div>
				}
			</div>
			{
				props.subtitle &&
				<div
					className={Styles.nsp_offer_item_card_price_dominant_subtitle}
				>
					<p>{props.subtitle}</p>
				</div>
			}
			{
				props.description &&
				<div
					className={Styles.nsp_offer_item_card_price_dominant_subtitle}
				>
					<p>{props.description}</p>
				</div>
			}

		</>
	);
}